import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 43292 43294"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        id="_1970275625776"
        d="M0 0v9775l11872 11872L0 33519v9775l21646-21647z"
        className="fil0"
      />
      <path
        id="_1970275626416"
        d="M21646 0v9775l11872 11872-11872 11872v9775l21646-21647z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
